import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { 
  LayoutDashboard, 
  Receipt, 
  Users, 
  TrendingUp, 
  AlertTriangle, 
  FileSpreadsheet,
  Target,
  FileText,
  FileInput,
  BarChart3,
  Calculator,
  Settings,
  LogOut,
  Briefcase,
  Sparkles,
  PieChart,
  Landmark,
  Download,
  ChevronDown
} from "lucide-react";

const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const navItems = [
    { to: "/", icon: LayoutDashboard, label: "Dashboard", section: "main" },
    { to: "/servizi-funerari", icon: Briefcase, label: "Servizi Funerari", section: "main" },
    { to: "/costs", icon: Receipt, label: "Costi Funerali", section: "main" },
    { to: "/fatture-attive", icon: FileText, label: "Fatture Attive", section: "fatture" },
    { to: "/fatture-passive", icon: FileInput, label: "Fatture Passive", section: "fatture" },
    { to: "/clients", icon: Users, label: "Clienti", section: "main" },
    { to: "/conti-bancari", icon: Landmark, label: "Conti Bancari", section: "banca" },
    { to: "/cashflow", icon: TrendingUp, label: "Cashflow 60gg", section: "analisi" },
    { to: "/ebit-ebitda", icon: PieChart, label: "EBIT & EBITDA", section: "analisi" },
    { to: "/riconciliazione", icon: Sparkles, label: "Riconciliazione AI", section: "banca" },
    { to: "/confronti", icon: BarChart3, label: "Confronti", section: "analisi" },
    { to: "/tasse", icon: Calculator, label: "Previsione Tasse", section: "analisi" },
    { to: "/breakeven", icon: Target, label: "Break Even", section: "analisi" },
    { to: "/simulator", icon: AlertTriangle, label: "Simulatore Crisi", section: "analisi" },
    { to: "/import-export", icon: FileSpreadsheet, label: "Import/Export", section: "tools" },
    { to: "/download", icon: Download, label: "Scarica App", section: "tools" },
    { to: "/impostazioni", icon: Settings, label: "Impostazioni", section: "tools" },
  ];

  return (
    <aside className="sidebar" data-testid="sidebar">
      <div className="sidebar-logo">
        <span className="text-[#007AFF]">Treasury</span> Dashboard
      </div>
      
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => 
              `sidebar-link ${isActive ? 'active' : ''}`
            }
            data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
            end={item.to === "/"}
          >
            <item.icon className="w-[18px] h-[18px]" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="sidebar-user-info">
            <p className="sidebar-user-name">{user?.name}</p>
            <p className="sidebar-user-email">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="sidebar-logout-btn"
          data-testid="logout-btn"
        >
          <LogOut className="w-4 h-4" />
          <span>Esci</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
